import React, { ReactNode } from 'react';

import { Container, ContainerProps } from '@mui/material';

import { Tbar } from 'components/docked';
import { TbarProps } from 'components/docked/Tbar';
import { useClientContext } from 'context/ClientContext';
import { useTitle } from 'hooks/useTitle';

interface OneColumnProps extends TbarProps {
    children: ReactNode;
    maxWidth?: ContainerProps['maxWidth'];
}

/**
 * Estrutura padrão do sistema para página do tipo 1 coluna (oneColumn) (sem aside)
 * Contém header + titulo + conteudo + footer
 */
export function OneColumn({ children, title, maxWidth = 'xl', ...tbarProps }: OneColumnProps) {
    const { documentTitle } = useClientContext();

    useTitle({ documentTitle, pageTitle: title });

    return (
        <Container
            component="main"
            maxWidth={maxWidth}
            disableGutters
            sx={{
                my: 3,
                flex: 1,
                px: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Tbar title={title} {...tbarProps} />

            {children}
        </Container>
    );
}
